import axios from 'axios';
import { getAuthHeaders } from '../contexts/AuthContext';

// A blob error body hides the server's JSON `detail`; read it back so error messages stay specific.
const readBlobError = async (error) => {
  const data = error?.response?.data;
  if (typeof Blob !== 'undefined' && data instanceof Blob && /json/i.test(data.type || '')) {
    try { error.response.data = JSON.parse(await data.text()); } catch { /* keep the blob */ }
  }
  return error;
};

const nameFrom = (header) => {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header || '');
  return match ? decodeURIComponent(match[1]) : null;
};

/** Download a file from the API. The server's Content-Disposition name wins when it sends one. */
export const downloadFile = async (url, filename) => {
  let response;
  try {
    response = await axios.get(url, { headers: getAuthHeaders(), responseType: 'blob' });
  } catch (error) {
    throw await readBlobError(error);
  }
  const href = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = href;
  link.download = nameFrom(response.headers?.['content-disposition']) || filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(href);
};

/** Save a base64 file returned as JSON ({ file, filename }) by template endpoints. */
export const saveBase64File = (base64, filename, type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') => {
  const blob = new Blob([Uint8Array.from(atob(base64), c => c.charCodeAt(0))], { type });
  const href = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(href);
};
